import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IThongKeCRMActionTypes } from "../../action-types/thong-ke/IThongKeCRMActions";
import { IThongKeCRMReducer } from "../../page-state-model/thong-ke/IThongKeCRMReducer";

const iniState: IThongKeCRMReducer = {
    statusChienDich: ePageBaseStatus.is_not_initialization,
    statusNguonBietToi: ePageBaseStatus.is_not_initialization,
    chienDichs: [],
    nguonBietTois: []
}
export const thongKeCRMReducer = (
    state: IThongKeCRMReducer = iniState,
    action: IThongKeCRMActionTypes
): IThongKeCRMReducer => {
    switch (action.type) {

        case "THONG_KE_CRM_LOAD_BY_CHIEN_DICH_START":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_loading
            }
        case "THONG_KE_CRM_LOAD_BY_CHIEN_DICH_SUCCESS":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_completed,
                chienDichs: action.payload
            }
        case "THONG_KE_CRM_LOAD_BY_CHIEN_DICH_ERROR":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_completed,
            }
        case "THONG_KE_CRM_LOAD_BY_NGUON_BIET_TOI_START":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_loading
            }
        case "THONG_KE_CRM_LOAD_BY_NGUON_BIET_TOI_SUCCESS":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_completed,
                nguonBietTois: action.payload
            }
        case "THONG_KE_CRM_LOAD_BY_NGUON_BIET_TOI_ERROR":
            return {
                ...state,
                statusChienDich: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}